module.exports = __webpack_public_path__ + "img/moment-of-bloom-2.02bd413b.webp";